type LumientLogoMarkProps = {
  className?: string;
  testId?: string;
};

const LumientLogoMark = ({
  className = "w-8 h-8 text-primary",
  testId,
}: LumientLogoMarkProps) => (
  <svg
    data-testid={testId}
    viewBox="70 890 330 280"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      fill="currentColor"
      d="M269.6 1149.3c-9.5-2.8-16.3-9.1-21.2-16.5-10.7-15.8-31.9-17.4-46.9-5.4-6.6 5.2-13.7 9.3-22.6 9.2-21.2-.2-37.4-20.6-33-41.4 3.8-17.7 16.5-28.6 35-26.9 6.6.6 12 3.6 16.6 8.2 6.4 6.4 13.1 12.4 22.4 14.3 9.6 1.9 18.2.4 25.7-6.9 7.1-6.8 14-14.2 24-17.3 21.8-6.6 47.2 7.8 53.3 27.3 9.2 29.6-14 57.9-40.6 57.4-4.1-.1-8.2-1.3-12.7-2.1zM150.4 963.7c-8.1-15.7-5.7-30 5.6-42 9.1-9.6 30.2-12.1 40.9-1.9 9.9 9.3 21.9 12.8 35.5 9.8 7.5-1.7 12.5-6.6 16.9-12.4 5.5-7.3 11.9-13.2 20.8-16.4 13.8-5.1 25.8-1 37.1 6.6 14 9.3 22.9 32.6 13.3 51.8-11.2 22.6-39.9 35.1-62.7 16.8-4.1-3.3-7.9-7.1-11.7-10.8-10.6-10.4-26.4-11.5-38.1-2.4-3.5 2.7-7.3 5.4-10.3 8.6-13 13.8-32.9 9.9-44-2.8-1.2-1.4-2.2-2.9-3.4-4.7z"
    />
    <path
      fill="currentColor"
      d="M277.3 1009.4c16.4 2 29.1-2.9 39-15 1.8-2.1 4.1-3.9 6.3-5.6 23.4-17.9 59.3-1.8 64.4 26.7 4 22.6-9 44.6-31 50.8-15.1 4.3-28.1-1.1-39.4-11.3-4.3-3.9-8.3-8.2-13-11.5-11.9-8.5-32.9-6.3-45.3 6.4-3.6 3.7-7.4 7.1-11.3 10.5-12 10.3-30.1 6.8-40.1-1.3-3.3-2.7-6.3-6-8.9-9.4-8.7-11.6-21.6-13.8-33.1-4.9-6.2 4.7-11.7 10.3-17.6 15.4-13.1 11.5-37.9 8.5-50.2-2.7-14.7-13.3-18.9-29.6-12.8-47.9 4.3-13 17.4-25.5 33.4-27.4 14.8-1.8 26.8 2.7 36.6 13.6 2.6 2.8 5.3 5.6 8.1 8.2 10.1 9.3 24.8 8.1 33.4-2.6 5.5-6.8 11.5-13 20.2-15.6 8.6-2.6 17.3-2.6 25.1 1.9 5.6 3.2 10.6 7.4 15.5 11.6 6.1 5.1 12.6 9.2 21.2 10.1z"
    />
  </svg>
);

export default LumientLogoMark;
